<template>
  <div>
    <h4 class="site-heading my-3"><span>Vocabularies</span></h4>
    <div class="form-row align-items-end" v-for="(vocabulary, index) in vocab">
      <div class="form-group col-md-11 required">
        <label class="control-label">Translate from</label>
        <input
          type="text"
          id="vocabulary.translate_from"
          name="vocabulary.translate_from"
          v-bind:class="{
            'has-error': errors.has('vocabulary.id'),
          }"
          v-validate="'required'"
          v-model="vocabulary.translate_from"
          class="form-control vocabulary.translate_from"
          placeholder="Translate from"
        />
        <div class="help text-danger" v-show="errors.has('vocabulary.id')">
          {{ errors.first("vocabulary.id") }}
        </div>
      </div>
      <div class="form-group col-md-11 required">
        <label class="control-label">Translate to</label>
        <input
          type="text"
          id="vocabulary.translate_to"
          name="vocabulary.translate_to"
          v-bind:class="{
            'has-error': errors.has('vocabulary.id'),
          }"
          v-validate="'required'"
          v-model="vocabulary.translate_to"
          class="form-control vocabulary.translate_to"
          placeholder="Translate to"
        />
        <div class="help text-danger" v-show="errors.has('vocabulary.id')">
          {{ errors.first("vocabulary.id") }}
        </div>
      </div>
      <div class="form-group col-md-11 required">
        <label class="control-label">Display Order</label>
        <input
          type="text"
          id="vocabulary.display_order"
          name="vocabulary.display_order"
          v-bind:class="{
            'has-error': errors.has('vocabulary.display_order'),
          }"
          v-validate="'required'"
          v-model="vocabulary.display_order"
          class="form-control vocabulary.display_order"
          placeholder="Display Order"
        />
        <div
          class="help text-danger"
          v-show="errors.has('vocabulary.display_order')"
        >
          {{ errors.first("vocabulary.display_order") }}
        </div>
      </div>
      <div class="form-group col-md-1">
        <button
          type="button"
          class="btn btn-danger float-right"
          @click="deleteVocabulary(index)"
        >
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
    <button type="button" @click="addVocabulary" class="btn btn-success">
      <i class="fa fa-plus"></i> New
    </button>
  </div>
</template>
<script>
export default {
  props: ["vocabularies"],
  data: () => ({
    vocab: [],
  }),
  methods: {
    addVocabulary: function () {
      this.vocab.push({});
    },
    deleteVocabulary: function (index) {
      this.vocab.splice(index, 1);
    },
  },
  watch: {
    vocabularies: function (val, oldVal) {
      this.vocab = val;
    },
  },
  updated() {
    this.$emit("updateVocabularies", this.vocab);
  },
};
</script>
